"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var merge_styles_1 = require("@uifabric/merge-styles");
exports.InjectionMode = merge_styles_1.InjectionMode;
exports.Stylesheet = merge_styles_1.Stylesheet;
exports.concatStyleSets = merge_styles_1.concatStyleSets;
exports.fontFace = merge_styles_1.fontFace;
exports.keyframes = merge_styles_1.keyframes;
exports.mergeStyleSets = merge_styles_1.mergeStyleSets;
exports.mergeStyles = merge_styles_1.mergeStyles;
//# sourceMappingURL=MergeStyles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/lib-commonjs/MergeStyles.js
// module id = 472
// module chunks = 0